import { i18n } from "@/boot/i18n";
import { USER_TREATMENT_OPTIONS } from "@/consts/general";

export default {
  profile: getUserStorage("t-profile"),
  profileEdit: {}
};

function getUserStorage(item) {
  if (typeof window !== "undefined") {
    try {
      const user = JSON.parse(localStorage.getItem(item));
      i18n.locale = user.primary_language;
      return user;
    } catch (error) {
      return {};
    }
  }
  return {};
}

export function getDefaultProfile() {
  return {
    name: null,
    email: null,
    phone: null,
    country_code: 55,
    primary_language: null,
    treatment: USER_TREATMENT_OPTIONS[0].value,
    primary_time_offset: null
  };
}
